import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const deleteTemplate = createAsyncThunk(
  "LeadTextTemplates/deleteTemplate",
  async (data, thunkAPI) => {
    const { handleSuccess, handleError } = data;
    try {
      const resp = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}api/templates/textMessage/${data?.templateId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (resp.data && handleSuccess) {
        handleSuccess();
      }
      return { ...resp.data, templateId: data?.templateId };
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        handleError(error.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
